module.exports = __webpack_public_path__ + "static/980-7990f282bb58ddf0212cb026ca738691.png";